import React from 'react';

interface RegisterProgressProps {
  step: number;
  totalSteps: number;
  label: string;
}

const RegisterProgress: React.FC<RegisterProgressProps> = ({ step, totalSteps, label }) => {
  const percent = (step / totalSteps) * 100;

  return (
    <div className="register-progress">
      <div className="register-progress__label">{label}</div>
      <div className="register-progress__track">
        <div className="register-progress__fill" style={{ width: `${percent}%` }} />
      </div>
    </div>
  );
};

export default RegisterProgress;
